import backgroundLineSvg from "images/Moon.svg";
import { FC } from "react";
import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionHero3Props {
  className?: string;
  title: string;
  subtitle: string;
  img: string;
  bg?: string;
}

const SectionHero3: FC<SectionHero3Props> = ({
  className = "",
  title,
  subtitle,
  img,
  bg = "#F7F0EA",
}) => {
  return (
    <div
      className={`nc-SectionHero3 relative ${className}`}
      data-nc-id="SectionHero3"
    >
      <div className="relative pt-8 lg:pt-0 lg:absolute z-10 inset-x-0 top-[10%] sm:top-[20%]  container">
        <div className="flex flex-col items-start max-w-lg xl:max-w-2xl space-y-5 xl:space-y-8 ">
          <span className="sm:text-lg md:text-xl font-semibold text-neutral-900">
            {subtitle}
          </span>
          <h2 className="font-bold text-black text-3xl sm:text-4xl md:text-5xl xl:text-6xl 2xl:text-7xl !leading-[115%] ">
            {title}
          </h2>
          <div className="sm:pt-4">
            <Link to={"/account-my-order"}>
              <ButtonPrimary
                sizeClass="px-6 py-3 lg:px-8 lg:py-4"
                fontSize="text-sm sm:text-base lg:text-lg font-medium"
              >
                Ver pedidos
              </ButtonPrimary>
            </Link>
          </div>
        </div>
      </div>

      <div className="relative z-[1] lg:aspect-[16/8] 2xl:aspect-[16/7]">
        <div className=" ">
          <div className="mt-5 lg:mt-0 lg:absolute right-0 bottom-0 top-0 w-full max-w-xl lg:max-w-2xl xl:max-w-3xl 2xl:max-w-4xl ml-auto">
            <img
              className="w-full sm:h-full object-contain object-right-bottom "
              src={img}
              alt=""
            />
          </div>
        </div>
      </div>

      {/* BG */}
      <div
        className={`absolute inset-0 bg-[${bg}] rounded-2xl overflow-hidden z-0`}
      >
        <img
          className="absolute w-full h-full object-contain"
          src={backgroundLineSvg}
          alt="hero"
        />
      </div>
    </div>
  );
};

export default SectionHero3;
